;(function () {
  angular
    .module('contrast.security-controls')
    .controller(
      'ModalAddControlInstanceCtrl',
      function (
        $scope,
        $uibModalInstance,
        logger,
        preloadValuesData,
        RuleFactory,
        appTracesApiConfig,
        securityControlsGuessTypeService,
        languageApiConfig,
        ErrorService,
        RuleService,
        securityControlService,
        AGENT_LANGUAGE,
        SECURITY_CONTROL_TYPES
      ) {
        'ngInject'

        var ALL_OPTION = { title: 'All Rules', name: 'All Rules' }

        angular.extend($scope, {
          control_types: securityControlService.getUserDefineControlTypes(),
          languages: [],
          rules: [],
          control: {
            type: SECURITY_CONTROL_TYPES.SANITIZER.value,
            all_rules: true
          },
          model: {
            rules: []
          },
          apiError: ''
        })

        angular.extend($scope, {
          onRulesUpdated: onRulesUpdated,
          onRulesDeleted: onRulesDeleted,
          ok: save,
          cancel: cancel,
          changeLanguage: changeLanguage,
          getApiClass: getApiClass,
          isNodeLanguage: isNodeLanguage,
          onControlApiChange: onControlApiChange
        })

        function init() {
          clearControls()

          loadLanguages()
            .then(preloadValues)
            .then(function () {
              $scope.control.language = preloadValuesData.language
            })
            .then(getRules)
            .then(_markApi)
            .then(attemptToGuessType)
            .catch(ErrorService.processError)
        }

        function preloadValues() {
          $scope.control.api = preloadValuesData.api
          if (preloadValuesData.traces && !preloadValuesData.mark_status) {
            if (preloadValuesData.traces.length == 1) {
              appTracesApiConfig.getEventApis(preloadValuesData.traces[0]).then(
                function (response) {
                  if (response.data.apis.length == 1) {
                    $scope.control.api = response.data.apis[0]
                    $scope.form.api.$setValidity('validApi', false)
                  } else {
                    $scope.apis = response.data.apis
                  }
                },
                function (response) {
                  ErrorService.processError(response)
                }
              )
            }
          }
        }

        function getRules() {
          $scope.rules = []
          $scope.model.rules = []
          RuleFactory.getEnabledRulesForControls($scope.control.language).then(
            function (response) {
              $scope.rules.push(ALL_OPTION)
              $scope.rules = _.union($scope.rules, response.data.rules)
              $scope.model.rules.push(ALL_OPTION)
            },
            function (response) {
              ErrorService.processError(response)
            }
          )
        }

        function clearControls() {
          $scope.control.api = ''
          $scope.control.name = ''
          $scope.control.all_rules = true
          $scope.model.rules = []
        }

        function _markApi() {
          return securityControlService
            .markApi($scope.control.api, $scope.control.language)
            .then(function (response) {
              $scope.control.api = response
            })
        }

        function attemptToGuessType() {
          var result = securityControlsGuessTypeService.attemptToGuessType(
            $scope.control.api
          )
          if (result) {
            $scope.control.type = result
          }
        }

        function onControlApiChange() {
          attemptToGuessType()
        }

        function save(addAnother) {
          var form = $scope.control
          var data = {
            name: form.name,
            api: form.api,
            language: form.language,
            all_rules: form.all_rules,
            module: form.module
          }
          if (!data.all_rules) {
            data.rules = $scope.model.rules
          }
          if (form.type == SECURITY_CONTROL_TYPES.SANITIZER.value) {
            if (
              preloadValuesData.traces &&
              preloadValuesData.traces.length == 1 &&
              preloadValuesData.mark_status
            ) {
              securityControlService
                .addSanitizerFromTrace(data, preloadValuesData.traces[0])
                .then(function (response) {
                  success(response, addAnother)
                })
            } else {
              securityControlService
                .addSanitizer(data)
                .then(function (response) {
                  success(response, addAnother)
                })
            }
          } else {
            if (
              preloadValuesData.traces &&
              preloadValuesData.traces.length == 1 &&
              preloadValuesData.mark_status
            ) {
              securityControlService
                .addValidatorFromTrace(data, preloadValuesData.traces[0])
                .then(function (messages) {
                  success(messages, addAnother)
                })
            } else {
              securityControlService
                .addValidator(data)
                .then(function (messages) {
                  success(messages, addAnother)
                })
            }
          }
        }

        function cancel() {
          $uibModalInstance.close('cancel')
        }

        function success(messages, addAnother) {
          logger.logSuccess(messages[0])
          if (!addAnother) {
            $uibModalInstance.close()
          } else {
            clearControls()
            $scope.model.rules.push(ALL_OPTION)
            $scope.form.$setPristine()
          }
        }

        function onRulesUpdated(item, model) {
          RuleService.onRulesUpdate($scope, item, model)
        }

        function onRulesDeleted(item, model) {
          RuleService.onRulesDelete($scope, item, model)
        }

        function loadLanguages() {
          return languageApiConfig.getLanguages().then(function (response) {
            var data = response.data
            // only Java and .NET are currently supported for Level One rules
            var languages = data.languages.filter(function (lang) {
              return (
                _.includes(AGENT_LANGUAGE.JAVA, lang) ||
                _.includes(AGENT_LANGUAGE.DOTNET, lang) ||
                _.includes(AGENT_LANGUAGE.DOTNET_CORE, lang) ||
                _.includes(AGENT_LANGUAGE.NODE, lang)
              )
            })

            $scope.languages = languages
          })
        }

        function changeLanguage() {
          if (
            _.includes(AGENT_LANGUAGE.DOTNET, $scope.control.language) ||
            _.includes(AGENT_LANGUAGE.DOTNET_CORE, $scope.control.language)
          ) {
            $scope.control.all_rules = true
            $scope.model.rules = []
            $scope.model.rules.push(ALL_OPTION)
          } else {
            getRules()
          }
        }

        function isNodeLanguage() {
          return _.includes(AGENT_LANGUAGE.NODE, $scope.control.language)
        }

        function getApiClass() {
          var result =
            angular.isDefined($scope.form.api) &&
            $scope.form.api.$invalid &&
            !$scope.form.api.$pristine
              ? 'has-error '
              : ''
          if (isNodeLanguage()) {
            return result + 'col-sm-6'
          }
          return result + 'col-sm-12'
        }

        init()
      }
    )
})()
